import BaseServiceCrud from './BaseServiceCrud';

export default class WelcomeSurveyService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'welcome-survey-manage';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria.locale,
            status: criteria.status?.enumValue,
            surveyVersion: criteria.surveyVersion,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }
    get(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element, lang, quizId) {
        return this.fetch(`${this.domain}/${this.path}/${lang}/${quizId}`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    remove(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    publish(id) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
